// extracted by mini-css-extract-plugin
module.exports = {"nft-collections-container":"NftCollections_nft-collections-container__S8XqZ","collections-list":"NftCollections_collections-list__iP9Hu"};